import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { useAppContext } from '@/context';
import { loadFeatureToggleService } from '@/services';
import { FEATURE_NAME } from '@/constants';
import { useAuth, useErrorHandler } from '@/hooks';

export const useFeatureToggle = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { state, dispatch } = useAppContext();
  const { isLoaded, data: featureToggle } = state.featureToggle;

  const errorHandler = useErrorHandler(() => {
    dispatch({ action: 'feature_toggle_load_end', payload: [] });
  });

  const canAccess = useMemo(
    () => isLoaded && featureToggle.map(({ feature }) => feature).includes(FEATURE_NAME),
    [isLoaded, featureToggle],
  );

  const loadFeatureToggle = () => {
    dispatch({ action: 'feature_toggle_load_start' });

    loadFeatureToggleService()
      .then((payload) => dispatch({ action: 'feature_toggle_load_end', payload }))
      .catch(errorHandler);
  };

  const handleAccess = () => {
    const isBeginnerPlan =
      auth.user.company.combo.name === 'Iniciante' || auth.user.company.combo.name === 'Iniciante Antigo';
    if (!isLoaded || (isBeginnerPlan && canAccess) || !isBeginnerPlan) return;
    navigate('/404');
  };

  useEffect(loadFeatureToggle, []);
  useEffect(handleAccess, [canAccess, isLoaded]);

  return { canAccess };
};
